module.exports = "/_next/static/images/classroomDefault-61270a65f526882cde4cdf0a015dd22d.png";